import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=93666d3a&scoped=true"
import script from "./CardPage.vue?vue&type=script&lang=js"
export * from "./CardPage.vue?vue&type=script&lang=js"
import style0 from "./CardPage.vue?vue&type=style&index=0&id=93666d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93666d3a",
  null
  
)

export default component.exports